export const facilityManagementRouteDef = [ 
    {
        path:'tariff_service_item',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path:'tariff_service_item_service',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path:'tariff_doctor_range',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path: 'patient_insured_amount_history',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            resource: 'patient_insured_amount_history',
            action: 'LIST',
        }
    },
    {
        path: 'smb_bed_bulk_entry',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'smb_bed_bulk_entry',
            action: 'ADD'
        }
    },
    {
        path:'tariff_doctor',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path:'tariff_surgery',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path:'tariff_room_rent',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path:':resource/:code/:resource/permission_set',
        component:'EditableGridWithBannerComponent',
        data : {
            selector: 'kx-editable-grid-with-banner'
        }
    },
    {
        path: 'ambulance_documents',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'ambulance_documents',
            title:'Ambulance Documents',
            searchType:'other',
            redirectToItself: true
        }
    },
    {
        path: 'driver_documents',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'driver_documents',
            title:'Driver Documents',
            searchType:'other',
            redirectToItself: true
        }
    },  {
        path: 'dashboard_master/:id',
        component: 'DashboardMasterComponent',
        data: {
            selector: 'app-dashboard-master'
        }

    },
    {
        path:'tariff_priority',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path: 'facility_form_template_config/:facility_id',
        component:'FacilityRoleMenuConfigComponent',
        data : {
            selector: 'app-facility-role-menu-config',
            resource: 'form_template_per_facility_view',
            action: 'LIST',

        }
    },
    {
        path: 'tariff_new',
        component: 'TariffScreenComponent',
        data: {
            selector: 'app-tariff-screen'
        }
    },
    {
        // Run Tariff Timeline Process (task #203132): job form + Show Data preview + Run
        path: 'tariff_timeline_run',
        component: 'TariffTimelineRunComponent',
        data: {
            selector: 'app-tariff-timeline-run'
        }
    },
    {
        path: ':id/:resource/modifyc',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_billing_category',
            id: 'id',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/viewyc',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_billing_category',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: ':id/:resource/modifycare',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_care_plan',
            id: 'id',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/viewycare',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_care_plan',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: ':resource/:id/viewcatalog',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'view_catalog_entry',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: ':id/:resource/modifyd',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_doctor',
            id: 'id',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/viewd',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_doctor',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: ':id/:resource/viewFixrate',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_wise_fixed_rate_view',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: ':id/:resource/modifyr',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_room_rent',
            id: 'id',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/viewr',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_room_rent',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: ':id/:resource/modifys',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_surgery',
            id: 'id',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/viewss',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_surgery',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: ':id/:resource/modifydr',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_department',
            id: 'id',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/viewdr',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tariff_service_item_department',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: 'facility_role_config/:facility_id',
        component:'FacilityRoleMenuConfigComponent',
        data : {
            selector: 'app-facility-role-menu-config',
            resource: 'role_per_facility_view',
            action: 'LIST',

        }
    },
    {
        path: 'facility_menu_config/:facility_id',
        component:'FacilityRoleMenuConfigComponent',
        data : {
            selector: 'app-facility-role-menu-config',
            resource: 'menu_per_facility_view',
            action: 'LIST',

        }
    },
    {
        path: 'csp_book_order/:type',
        component:'CSPOrderComponenet',
        data : {
            selector: 'app-csp-order',
            action: 'LIST',
            resource:'csp_facility'
        }
    },
    {
        path: 'supplier_book_order/:type',
        component:'ScmOrderComponent',
        data : {
            selector: 'app-scm-order',
            action: 'LIST',
            resource:'supplier_facility'
        }
    },
    {
        path: 'symptom_bot',
        component:'SystemBotComponent',
        data : {
            selector: 'app-system-bot'
        }
    },
    {
        path: 'duty_roaster_add',
        component:'DutyRoasterComponent',
        data : {
            selector: 'app-duty-roaster'
        }
    },
    {
        path: ':id/:data/duty_roaster_view',
        component:'DutyRoasterComponent',
        data : {
            selector: 'app-duty-roaster'
        }
    },
    {
        path: 'duty_roaster_ward_transfer',
        component:'DutyRoasterComponent',
        data : {
            selector: 'app-duty-roaster'
        }
    },
    {
        path: 'duty_roaster_shift_change',
        component:'DutyRoasterComponent',
        data : {
            selector: 'app-duty-roaster'
        }
    },
    {
        path: 'duty_roaster_update',
        component:'DutyRoasterComponent',
        data : {
            selector: 'app-duty-roaster'
        }
    },
    {
        path: ':resource/symptom_bot/:id/:action',
        component:'SystemBotComponent',
        data : {
            selector: 'app-system-bot'
        }
    },
    {
        path: 'csp_book_order/:type/:sub_type',
        component:'CSPOrderComponenet',
        data : {
            selector: 'app-csp-order',
            action: 'LIST',
            resource:'csp_facility'
        }
    },
    {
        path: ':id/:resource/profile',
        component: 'GenericProfileComponent',
        data: {
            selector: 'app-generic-profile'
        }
    },
    {
        path:'tariff_department',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path: 'organ_specification',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'organ_specification',
        }
    },
    {
        path: ':resource/:id/doctor-profile',
        component: 'ProfileComponent',
        data: {
            selector: 'kx-profile'
        }
    },
    // {
    //     path: 'google-fit',
    //     component: 'GooglefitComponent',
    //     data: {
    //         selector: 'app-google-fit'
    //     }
    // },
    {
        path: ':id/:resource/exclude_resource',
        component: 'ExcludeResourceComponent',
        data : {
            selector: 'app-exclude-resource'
        }
    },
    {
        path: 'load_resource/:resource',
        component:'ResourceLoaderComponent',
        data:{
            selector:'resource-loader'
        }
    },
    {
        path: 'load_resource',
        component:'ResourceLoaderComponent',
        data:{
            selector:'resource-loader'
        }
    }
]       

